export default __webpack_public_path__ + "static/media/img10.298f1410.PNG";